/**
 * Static PDP thumbnail rail click-to-select.
 *
 * When thumb count <= 4 (fits one page — Figma 59:2730 / 59:32139), sections/main-product.liquid
 * renders the sublist WITHOUT `js-media-sublist swiper`, so Motto's vendored subSliderInit
 * (assets/global.js) never creates a Swiper and the rail stays static. That removes Swiper's
 * `thumbs`/`slideToClickedSlide` linkage, so a thumb click no longer drives the hero. This restores
 * it: a delegated click on each static thumb calls the MAIN media Swiper's slideTo(index).
 * No vendored JS is touched. Index alignment: the static sublist emits the featured media first then
 * every other media in the same order as the main list, so sublist child index === main slide index.
 */
const RAIL = '.product__media-sublist--static';

function mainSwiperFor(el) {
  const wrapper = el.closest('.product__media-list-wrapper');
  const list = wrapper && wrapper.querySelector('.js-media-list');
  return list && list.swiper && !list.swiper.destroyed ? list.swiper : null;
}

function bind(rail) {
  if (rail.dataset.staticThumbBound === 'true') return;
  rail.dataset.staticThumbBound = 'true';
  Array.from(rail.querySelectorAll('.product__media-subitem')).forEach(
    (item, index) => {
      item.addEventListener('click', () => {
        const swiper = mainSwiperFor(rail);
        if (swiper) swiper.slideTo(index);
      });
    }
  );
}

function scan() {
  document.querySelectorAll(RAIL).forEach(bind);
}

export default function initStaticThumbRail() {
  scan();
  document.addEventListener('shopify:section:load', () =>
    window.setTimeout(scan, 50)
  );
}
